import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { replacePathParams } from "@exonn/utils";
import {
  ProductFormTabs,
  VariantFormTabs,
} from "src/admin/modules/product/constants.ts";
import {
  type ProductRowResource,
  ProductRowType,
} from "src/framework/listV2/types.ts";

export const getProductRowPath = ({ row }: { row: ProductRowResource }) => {
  const moduleRoutePaths = createModuleRoutePaths({
    resource: ResourceEnum.Product,
  });
  if (
    [
      ProductRowType.Multiple,
      ProductRowType.Set,
      ProductRowType.Single,
      ProductRowType.Complex,
    ].includes(row.type)
  ) {
    return replacePathParams(moduleRoutePaths.edit.root, {
      id: row.id,
    });
  }
  if (
    [
      ProductRowType.MultipleVariant,
      ProductRowType.ComplexVariant,
      ProductRowType.ComplexSetVariant,
    ].includes(row.type)
  ) {
    const [productId] = row.path;
    return replacePathParams(
      moduleRoutePaths.edit.tab(ProductFormTabs.Variants).tab(":variant_id")
        .root,
      {
        id: productId,
        variant_id: row.id,
      },
    );
  }

  if (row.type == ProductRowType.ComplexSetVariantComponent) {
    const [productId, variantId, componentId] = row.path;
    return (
      replacePathParams(
        moduleRoutePaths.edit
          .tab(ProductFormTabs.Variants)
          .tab(":variant_id")
          .tab(VariantFormTabs.Components).root,
        {
          id: productId,
          variant_id: variantId,
        },
      ) + `?component_id=${componentId}`
    );
  }

  if (row.type == ProductRowType.SetComponent) {
    const [productId, componentId] = row.path;
    return (
      replacePathParams(
        moduleRoutePaths.edit.tab(ProductFormTabs.Components).root,
        {
          id: productId,
        },
      ) + `?component_id=${componentId}`
    );
  }
  throw new Error("unknown row type");
};
